import { types } from 'mobx-state-tree';

import { Contact } from '../definitions/Common';


const Applicant = types.compose(
    'Applicant',
    Contact,
    types.model({
        hasConsumedTobacco: types.maybeNull(types.boolean),
        // Disability Coverage Fields
        isCanadianCitizen: types.maybeNull(types.boolean),
        grossAnnualIncome: types.maybeNull(types.number),
        occupation: types.maybeNull(types.string),
    }),
);

export default Applicant;
